// KWANKGM03110_住宅ローンしっかり審査事前審査申込入力詳細
import React from 'react';
import TopArea from '../../molecules/TopArea';
import Reception from '../../templates/Reception';
import { StepNavigation as StepType } from '../../types/Template';
import { ParentShelf, ChildShelf, Content, GuarantorInfo } from '../../types/Template';
import LoadingModal from '../../molecules/LoadingModal';
import FooterPreExaminationApplicationHousingLoanFirmlyInputDetail from '../../organisms/FooterPreExaminationApplicationHousingLoanFirmlyInputDetail';

interface Props {
  step_navigation: StepType;
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  looks_inactive: boolean;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  reception_id: number;
  status_code: number;
  is_staff: boolean;
  opened_mypage: boolean;
  moveNextStep: () => void;
  guarantors_num: number;
  is_loading: boolean;
  show_error_nav: boolean;
  display_status: boolean;
  requestModule: () => void;
  callApi: (function_name: string) => Promise<any>;
  guarantor_info: GuarantorInfo;
  is_bank_exists?: boolean;
  is_desired_bank_exists?: boolean;
  is_ja_exists?: boolean;
  is_mypage_ja?: boolean;
  setShowErrorNav: React.Dispatch<React.SetStateAction<boolean>>;
  handleClickTempSave: () => void;
  setStepNavigation: React.Dispatch<React.SetStateAction<StepType>>;
  requestModuleAutodisplay: () => void;
}

const PreExaminationInputHousingLoanFirmly: React.FC<Props> = ({
  step_navigation,
  reception_cd,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  looks_inactive,
  parent_shelfs,
  child_shelfs,
  contents,
  setParentShelfs,
  setChildShelfs,
  setContents,
  reception_id,
  status_code,
  is_staff,
  opened_mypage,
  moveNextStep,
  guarantors_num,
  is_loading,
  show_error_nav,
  display_status,
  requestModule,
  callApi,
  guarantor_info,
  is_bank_exists,
  is_desired_bank_exists,
  is_ja_exists,
  is_mypage_ja,
  setShowErrorNav,
  handleClickTempSave,
  setStepNavigation,
  requestModuleAutodisplay,
}) => {
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <Reception
        parent_shelfs={parent_shelfs}
        child_shelfs={child_shelfs}
        contents={contents}
        setParentShelfs={setParentShelfs}
        setChildShelfs={setChildShelfs}
        setContents={setContents}
        looks_inactive={looks_inactive}
        guarantors_num={guarantors_num}
        show_error_nav={show_error_nav}
        callApi={callApi}
        guarantor_info={guarantor_info}
        is_bank_exists={is_bank_exists}
        is_desired_bank_exists={is_desired_bank_exists}
        is_ja_exists={is_ja_exists}
        is_mypage_ja={is_mypage_ja}
        setShowErrorNav={setShowErrorNav}
      />
      <FooterPreExaminationApplicationHousingLoanFirmlyInputDetail
        opened_mypage={opened_mypage}
        is_staff={is_staff}
        reception_id={reception_id}
        reception_cd={reception_cd}
        status_code={status_code}
        moveNextStep={moveNextStep}
        requestModule={requestModule}
        handleClickTempSave={handleClickTempSave}
        setStepNavigation={setStepNavigation}
        requestModuleAutodisplay={requestModuleAutodisplay}
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default PreExaminationInputHousingLoanFirmly;
